/**
 * "How your donation works" — an animated CSS/SVG money-flow diagram (no motion lib).
 * A gold token travels Donor → NGO account → Beneficiary along an SVG path via
 * @keyframes offset-distance. Respects prefers-reduced-motion (token hidden).
 */
import { Heart, ShieldCheck, Landmark, HandHeart } from 'lucide-react';
import styles from './DonationFlow.module.css';

const STEPS = [
  { icon: Heart, title: 'You give', body: 'By bank transfer, UPI or in person — arranged directly with our team.' },
  { icon: ShieldCheck, title: 'Confirmed & recorded', body: 'We confirm your contribution and record it against the ledger, dated and attributed.' },
  { icon: Landmark, title: 'NGO account', body: 'Funds sit in the dedicated NGO account. Every rupee flows through the system.' },
  { icon: HandHeart, title: 'A real case', body: 'Disbursed to a verified beneficiary — or paid vendor-direct to a shop or hospital.' },
];

export function DonationFlow() {
  return (
    <section className={styles.section}>
      <div className="container">
        <p className="eyebrow">How your donation works</p>
        <h2 className={styles.title}>From your phone to a verified case.</h2>

        <div className={styles.diagram} aria-hidden="true">
          <svg viewBox="0 0 1000 60" className={styles.path} preserveAspectRatio="none">
            <path id="flowPath" d="M40 30 H960" fill="none" stroke="var(--line)" strokeWidth="2" strokeDasharray="6 6" />
            <circle r="7" fill="var(--gold-500)" className={styles.token} />
          </svg>
        </div>

        <div className={styles.steps}>
          {STEPS.map((s, i) => (
            <div key={s.title} className={styles.step}>
              <span className={styles.stepNum}>{i + 1}</span>
              <span className={styles.stepIcon}>
                <s.icon size={24} />
              </span>
              <strong>{s.title}</strong>
              <p>{s.body}</p>
            </div>
          ))}
        </div>

        <p className={styles.foot}>
          No foreign cards until FCRA registration. Receipts and an 80G module follow once
          RNPO status is active.
        </p>
      </div>
    </section>
  );
}

export default DonationFlow;
